import { Grid, Typography } from "@material-ui/core";
import { Split } from "../../utils/Split";
import { convertNumbers } from "../../utils/ConvertNumbers";
import { Link } from "react-router-dom";

const HeaderItem = (props) => {
  return (
    <Grid
      style={{
        borderBottom: "1px solid #d9dee4",
        paddingBottom: "12px",
      }}
      item
      xs={6}
      sm={6}
      md={4}
      lg={2}
    >
      <Link to={props.data.link} style={{ textDecoration: "none" }}>
        <Grid
          style={{
            borderLeft: "2px solid #adb2b5",
            color: "#73879c",
          }}
        >
          <Grid
            style={{ fontSize: "14px" }}
            container
            direction="row"
            alignItems="center"
            justifyContent="center"
          >
            <Grid style={{ marginLeft: "2px" }} item>
              {props.data.icon}
            </Grid>
            <Grid item>{props.data.name}</Grid>
          </Grid>
          <Grid
            container
            direction="row"
            alignItems="center"
            justifyContent="center"
          >
            <Grid style={{ fontSize: "32px", fontWeight: "bold" }} item>
              {Split(convertNumbers(props.data.value))}
            </Grid>
          </Grid>
        </Grid>
      </Link>
    </Grid>
  );
};

export default HeaderItem;
